import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/admin/services/user.service';
import { validateAddUser } from 'src/app/utils/formValidators';
import { AccountService } from 'src/app/services/account.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['./add-user-modal.component.scss'],
})
export class AddUserModalComponent implements OnInit {

  managers: any[];
  user: User = new User();
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  errMsg: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  itemsPerPageLarge: number = 2147483647;
  paginationSettings = { totalItems: 0 };
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  usernameQuery: string = ''
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  firstNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  lastNameQuery: string = '';
  idCardNoQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  currentRole: string;
  loggedUser$ = this.accountService.currentUser$;
  address: string;
  surname: string;
  name: string;
  lk: string;
  username: string;
  oper: number;
  messageError: string
  constructor(private modalController: ModalController,
    private userService: UserService,
    private accountService: AccountService) { }

  ngOnInit() {
    let currentUser;
    this.accountService.currentUser$.pipe(take(1)).subscribe(user => currentUser = user);
    this.currentRole = currentUser.role.toLowerCase();

    if (this.currentRole == 'manager') {
      this.user.managerId = currentUser.nameid;
      this.user.role = 'Employee';
    }
    console.log('CURRENTUSER', currentUser)
    console.log('CURRENTrole', this.currentRole)
    console.log('opper', this.oper)
    console.log('loggedUser$', this.loggedUser$)

  }

  addUser() {

    console.log('OPERSTERpre', this.user)
    const formValidation = validateAddUser(this.user)
    console.log('OPERSTER', this.user)
    this.errMsg = formValidation.errMsg;
    if (formValidation.isValid) {
      this.userService.addUser(this.user).subscribe(res => {
        this.userService.getAllUsers({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          usernameQuery: this.usernameQuery, firstNameQuery: this.firstNameQuery, lastNameQuery: this.lastNameQuery,
          idCardNoQuery: this.idCardNoQuery
        });
        this.dismissModal();
      }, (err) => {

        if (err.error.errors.includes('username-is-already-registered')) {
          this.messageError = 'Greška: Korisničko ime već postoji u sistemu.';
        }

        else if (err.error.errors.includes('id-card-is-already-registered')) {
          this.messageError = 'Greška: Broj lične karte je već upisan u sistemu.';
        }

        else if (err.error.errors.includes('OperatorId-is-already-exists')) {
          this.messageError = 'Greška: Id operatera već postoji u sistemu.';
        }
        this.errMsg = this.messageError
      })
    }
  }

  dismissModal() {
    this.modalController.dismiss();
  }

}
